import { lazy } from "react";

export const PhotoGallery = lazy(() => import("../../Features/PhotoGallery"));
